var map = {
	"./hombre/boca/labios-gruesos.png": 1301,
	"./hombre/boca/labios-normal.png": 1302,
	"./mujer/boca/boca-delgada.png": 1303,
	"./mujer/boca/labios-gruesos.png": 1304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;